import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { agentService } from '../../services/agentService';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import './UserEditModal.css';
import './MajesticModal.css';

// Comprehensive Country codes list with flag emojis
const countryCodes = [
  { code: '+93', country: 'AF', flag: '🇦🇫', name: 'Afghanistan' },
  { code: '+355', country: 'AL', flag: '🇦🇱', name: 'Albania' },
  { code: '+213', country: 'DZ', flag: '🇩🇿', name: 'Algeria' },
  { code: '+1-684', country: 'AS', flag: '🇦🇸', name: 'American Samoa' },
  { code: '+376', country: 'AD', flag: '🇦🇩', name: 'Andorra' },
  { code: '+244', country: 'AO', flag: '🇦🇴', name: 'Angola' },
  { code: '+1-264', country: 'AI', flag: '🇦🇮', name: 'Anguilla' },
  { code: '+672', country: 'AQ', flag: '🇦🇶', name: 'Antarctica' },
  { code: '+1-268', country: 'AG', flag: '🇦🇬', name: 'Antigua and Barbuda' },
  { code: '+54', country: 'AR', flag: '🇦🇷', name: 'Argentina' },
  { code: '+374', country: 'AM', flag: '🇦🇲', name: 'Armenia' },
  { code: '+297', country: 'AW', flag: '🇦🇼', name: 'Aruba' },
  { code: '+61', country: 'AU', flag: '🇦🇺', name: 'Australia' },
  { code: '+43', country: 'AT', flag: '🇦🇹', name: 'Austria' },
  { code: '+994', country: 'AZ', flag: '🇦🇿', name: 'Azerbaijan' },
  { code: '+1-242', country: 'BS', flag: '🇧🇸', name: 'Bahamas' },
  { code: '+973', country: 'BH', flag: '🇧🇭', name: 'Bahrain' },
  { code: '+880', country: 'BD', flag: '🇧🇩', name: 'Bangladesh' },
  { code: '+1-246', country: 'BB', flag: '🇧🇧', name: 'Barbados' },
  { code: '+375', country: 'BY', flag: '🇧🇾', name: 'Belarus' },
  { code: '+32', country: 'BE', flag: '🇧🇪', name: 'Belgium' },
  { code: '+501', country: 'BZ', flag: '🇧🇿', name: 'Belize' },
  { code: '+229', country: 'BJ', flag: '🇧🇯', name: 'Benin' },
  { code: '+1-441', country: 'BM', flag: '🇧🇲', name: 'Bermuda' },
  { code: '+975', country: 'BT', flag: '🇧🇹', name: 'Bhutan' },
  { code: '+591', country: 'BO', flag: '🇧🇴', name: 'Bolivia' },
  { code: '+387', country: 'BA', flag: '🇧🇦', name: 'Bosnia and Herzegovina' },
  { code: '+267', country: 'BW', flag: '🇧🇼', name: 'Botswana' },
  { code: '+55', country: 'BR', flag: '🇧🇷', name: 'Brazil' },
  { code: '+246', country: 'IO', flag: '🇮🇴', name: 'British Indian Ocean Territory' },
  { code: '+1-284', country: 'VG', flag: '🇻🇬', name: 'British Virgin Islands' },
  { code: '+673', country: 'BN', flag: '🇧🇳', name: 'Brunei' },
  { code: '+359', country: 'BG', flag: '🇧🇬', name: 'Bulgaria' },
  { code: '+226', country: 'BF', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: '+257', country: 'BI', flag: '🇧🇮', name: 'Burundi' },
  { code: '+855', country: 'KH', flag: '🇰🇭', name: 'Cambodia' },
  { code: '+237', country: 'CM', flag: '🇨🇲', name: 'Cameroon' },
  { code: '+1', country: 'CA', flag: '🇨🇦', name: 'Canada' },
  { code: '+238', country: 'CV', flag: '🇨🇻', name: 'Cape Verde' },
  { code: '+599', country: 'BQ', flag: '🇧🇶', name: 'Caribbean Netherlands' },
  { code: '+1-345', country: 'KY', flag: '🇰🇾', name: 'Cayman Islands' },
  { code: '+236', country: 'CF', flag: '🇨🇫', name: 'Central African Republic' },
  { code: '+235', country: 'TD', flag: '🇹🇩', name: 'Chad' },
  { code: '+56', country: 'CL', flag: '🇨🇱', name: 'Chile' },
  { code: '+86', country: 'CN', flag: '🇨🇳', name: 'China' },
  { code: '+61', country: 'CX', flag: '🇨🇽', name: 'Christmas Island' },
  { code: '+61', country: 'CC', flag: '🇨🇨', name: 'Cocos (Keeling) Islands' },
  { code: '+57', country: 'CO', flag: '🇨🇴', name: 'Colombia' },
  { code: '+269', country: 'KM', flag: '🇰🇲', name: 'Comoros' },
  { code: '+243', country: 'CD', flag: '🇨🇩', name: 'Congo (DRC)' },
  { code: '+242', country: 'CG', flag: '🇨🇬', name: 'Congo (Republic)' },
  { code: '+682', country: 'CK', flag: '🇨🇰', name: 'Cook Islands' },
  { code: '+506', country: 'CR', flag: '🇨🇷', name: 'Costa Rica' },
  { code: '+225', country: 'CI', flag: '🇨🇮', name: 'Ivory Coast' },
  { code: '+385', country: 'HR', flag: '🇭🇷', name: 'Croatia' },
  { code: '+53', country: 'CU', flag: '🇨🇺', name: 'Cuba' },
  { code: '+599', country: 'CW', flag: '🇨🇼', name: 'Curaçao' },
  { code: '+357', country: 'CY', flag: '🇨🇾', name: 'Cyprus' },
  { code: '+420', country: 'CZ', flag: '🇨🇿', name: 'Czech Republic' },
  { code: '+45', country: 'DK', flag: '🇩🇰', name: 'Denmark' },
  { code: '+253', country: 'DJ', flag: '🇩🇯', name: 'Djibouti' },
  { code: '+1-767', country: 'DM', flag: '🇩🇲', name: 'Dominica' },
  { code: '+1-809', country: 'DO', flag: '🇩🇴', name: 'Dominican Republic' },
  { code: '+593', country: 'EC', flag: '🇪🇨', name: 'Ecuador' },
  { code: '+20', country: 'EG', flag: '🇪🇬', name: 'Egypt' },
  { code: '+503', country: 'SV', flag: '🇸🇻', name: 'El Salvador' },
  { code: '+240', country: 'GQ', flag: '🇬🇶', name: 'Equatorial Guinea' },
  { code: '+291', country: 'ER', flag: '🇪🇷', name: 'Eritrea' },
  { code: '+372', country: 'EE', flag: '🇪🇪', name: 'Estonia' },
  { code: '+251', country: 'ET', flag: '🇪🇹', name: 'Ethiopia' },
  { code: '+500', country: 'FK', flag: '🇫🇰', name: 'Falkland Islands' },
  { code: '+298', country: 'FO', flag: '🇫🇴', name: 'Faroe Islands' },
  { code: '+679', country: 'FJ', flag: '🇫🇯', name: 'Fiji' },
  { code: '+358', country: 'FI', flag: '🇫🇮', name: 'Finland' },
  { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
  { code: '+594', country: 'GF', flag: '🇬🇫', name: 'French Guiana' },
  { code: '+689', country: 'PF', flag: '🇵🇫', name: 'French Polynesia' },
  { code: '+241', country: 'GA', flag: '🇬🇦', name: 'Gabon' },
  { code: '+220', country: 'GM', flag: '🇬🇲', name: 'Gambia' },
  { code: '+995', country: 'GE', flag: '🇬🇪', name: 'Georgia' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
  { code: '+233', country: 'GH', flag: '🇬🇭', name: 'Ghana' },
  { code: '+350', country: 'GI', flag: '🇬🇮', name: 'Gibraltar' },
  { code: '+30', country: 'GR', flag: '🇬🇷', name: 'Greece' },
  { code: '+299', country: 'GL', flag: '🇬🇱', name: 'Greenland' },
  { code: '+1-473', country: 'GD', flag: '🇬🇩', name: 'Grenada' },
  { code: '+590', country: 'GP', flag: '🇬🇵', name: 'Guadeloupe' },
  { code: '+1-671', country: 'GU', flag: '🇬🇺', name: 'Guam' },
  { code: '+502', country: 'GT', flag: '🇬🇹', name: 'Guatemala' },
  { code: '+44-1481', country: 'GG', flag: '🇬🇬', name: 'Guernsey' },
  { code: '+224', country: 'GN', flag: '🇬🇳', name: 'Guinea' },
  { code: '+245', country: 'GW', flag: '🇬🇼', name: 'Guinea-Bissau' },
  { code: '+592', country: 'GY', flag: '🇬🇾', name: 'Guyana' },
  { code: '+509', country: 'HT', flag: '🇭🇹', name: 'Haiti' },
  { code: '+504', country: 'HN', flag: '🇭🇳', name: 'Honduras' },
  { code: '+852', country: 'HK', flag: '🇭🇰', name: 'Hong Kong' },
  { code: '+36', country: 'HU', flag: '🇭🇺', name: 'Hungary' },
  { code: '+354', country: 'IS', flag: '🇮🇸', name: 'Iceland' },
  { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
  { code: '+62', country: 'ID', flag: '🇮🇩', name: 'Indonesia' },
  { code: '+98', country: 'IR', flag: '🇮🇷', name: 'Iran' },
  { code: '+964', country: 'IQ', flag: '🇮🇶', name: 'Iraq' },
  { code: '+353', country: 'IE', flag: '🇮🇪', name: 'Ireland' },
  { code: '+44-1624', country: 'IM', flag: '🇮🇲', name: 'Isle of Man' },
  { code: '+972', country: 'IL', flag: '🇮🇱', name: 'Israel' },
  { code: '+39', country: 'IT', flag: '🇮🇹', name: 'Italy' },
  { code: '+1-876', country: 'JM', flag: '🇯🇲', name: 'Jamaica' },
  { code: '+81', country: 'JP', flag: '🇯🇵', name: 'Japan' },
  { code: '+44-1534', country: 'JE', flag: '🇯🇪', name: 'Jersey' },
  { code: '+962', country: 'JO', flag: '🇯🇴', name: 'Jordan' },
  { code: '+7', country: 'KZ', flag: '🇰🇿', name: 'Kazakhstan' },
  { code: '+254', country: 'KE', flag: '🇰🇪', name: 'Kenya' },
  { code: '+686', country: 'KI', flag: '🇰🇮', name: 'Kiribati' },
  { code: '+383', country: 'XK', flag: '🇽🇰', name: 'Kosovo' },
  { code: '+965', country: 'KW', flag: '🇰🇼', name: 'Kuwait' },
  { code: '+996', country: 'KG', flag: '🇰🇬', name: 'Kyrgyzstan' },
  { code: '+856', country: 'LA', flag: '🇱🇦', name: 'Laos' },
  { code: '+371', country: 'LV', flag: '🇱🇻', name: 'Latvia' },
  { code: '+961', country: 'LB', flag: '🇱🇧', name: 'Lebanon' },
  { code: '+266', country: 'LS', flag: '🇱🇸', name: 'Lesotho' },
  { code: '+231', country: 'LR', flag: '🇱🇷', name: 'Liberia' },
  { code: '+218', country: 'LY', flag: '🇱🇾', name: 'Libya' },
  { code: '+423', country: 'LI', flag: '🇱🇮', name: 'Liechtenstein' },
  { code: '+370', country: 'LT', flag: '🇱🇹', name: 'Lithuania' },
  { code: '+352', country: 'LU', flag: '🇱🇺', name: 'Luxembourg' },
  { code: '+853', country: 'MO', flag: '🇲🇴', name: 'Macau' },
  { code: '+389', country: 'MK', flag: '🇲🇰', name: 'North Macedonia' },
  { code: '+261', country: 'MG', flag: '🇲🇬', name: 'Madagascar' },
  { code: '+265', country: 'MW', flag: '🇲🇼', name: 'Malawi' },
  { code: '+60', country: 'MY', flag: '🇲🇾', name: 'Malaysia' },
  { code: '+960', country: 'MV', flag: '🇲🇻', name: 'Maldives' },
  { code: '+223', country: 'ML', flag: '🇲🇱', name: 'Mali' },
  { code: '+356', country: 'MT', flag: '🇲🇹', name: 'Malta' },
  { code: '+692', country: 'MH', flag: '🇲🇭', name: 'Marshall Islands' },
  { code: '+596', country: 'MQ', flag: '🇲🇶', name: 'Martinique' },
  { code: '+222', country: 'MR', flag: '🇲🇷', name: 'Mauritania' },
  { code: '+230', country: 'MU', flag: '🇲🇺', name: 'Mauritius' },
  { code: '+262', country: 'YT', flag: '🇾🇹', name: 'Mayotte' },
  { code: '+52', country: 'MX', flag: '🇲🇽', name: 'Mexico' },
  { code: '+691', country: 'FM', flag: '🇫🇲', name: 'Micronesia' },
  { code: '+373', country: 'MD', flag: '🇲🇩', name: 'Moldova' },
  { code: '+377', country: 'MC', flag: '🇲🇨', name: 'Monaco' },
  { code: '+976', country: 'MN', flag: '🇲🇳', name: 'Mongolia' },
  { code: '+382', country: 'ME', flag: '🇲🇪', name: 'Montenegro' },
  { code: '+1-664', country: 'MS', flag: '🇲🇸', name: 'Montserrat' },
  { code: '+212', country: 'MA', flag: '🇲🇦', name: 'Morocco' },
  { code: '+258', country: 'MZ', flag: '🇲🇿', name: 'Mozambique' },
  { code: '+95', country: 'MM', flag: '🇲🇲', name: 'Myanmar' },
  { code: '+264', country: 'NA', flag: '🇳🇦', name: 'Namibia' },
  { code: '+674', country: 'NR', flag: '🇳🇷', name: 'Nauru' },
  { code: '+977', country: 'NP', flag: '🇳🇵', name: 'Nepal' },
  { code: '+31', country: 'NL', flag: '🇳🇱', name: 'Netherlands' },
  { code: '+687', country: 'NC', flag: '🇳🇨', name: 'New Caledonia' },
  { code: '+64', country: 'NZ', flag: '🇳🇿', name: 'New Zealand' },
  { code: '+505', country: 'NI', flag: '🇳🇮', name: 'Nicaragua' },
  { code: '+227', country: 'NE', flag: '🇳🇪', name: 'Niger' },
  { code: '+234', country: 'NG', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+683', country: 'NU', flag: '🇳🇺', name: 'Niue' },
  { code: '+672', country: 'NF', flag: '🇳🇫', name: 'Norfolk Island' },
  { code: '+850', country: 'KP', flag: '🇰🇵', name: 'North Korea' },
  { code: '+1-670', country: 'MP', flag: '🇲🇵', name: 'Northern Mariana Islands' },
  { code: '+47', country: 'NO', flag: '🇳🇴', name: 'Norway' },
  { code: '+968', country: 'OM', flag: '🇴🇲', name: 'Oman' },
  { code: '+92', country: 'PK', flag: '🇵🇰', name: 'Pakistan' },
  { code: '+680', country: 'PW', flag: '🇵🇼', name: 'Palau' },
  { code: '+970', country: 'PS', flag: '🇵🇸', name: 'Palestine' },
  { code: '+507', country: 'PA', flag: '🇵🇦', name: 'Panama' },
  { code: '+675', country: 'PG', flag: '🇵🇬', name: 'Papua New Guinea' },
  { code: '+595', country: 'PY', flag: '🇵🇾', name: 'Paraguay' },
  { code: '+51', country: 'PE', flag: '🇵🇪', name: 'Peru' },
  { code: '+63', country: 'PH', flag: '🇵🇭', name: 'Philippines' },
  { code: '+64', country: 'PN', flag: '🇵🇳', name: 'Pitcairn' },
  { code: '+48', country: 'PL', flag: '🇵🇱', name: 'Poland' },
  { code: '+351', country: 'PT', flag: '🇵🇹', name: 'Portugal' },
  { code: '+1-787', country: 'PR', flag: '🇵🇷', name: 'Puerto Rico' },
  { code: '+974', country: 'QA', flag: '🇶🇦', name: 'Qatar' },
  { code: '+262', country: 'RE', flag: '🇷🇪', name: 'Reunion' },
  { code: '+40', country: 'RO', flag: '🇷🇴', name: 'Romania' },
  { code: '+7', country: 'RU', flag: '🇷🇺', name: 'Russia' },
  { code: '+250', country: 'RW', flag: '🇷🇼', name: 'Rwanda' },
  { code: '+590', country: 'BL', flag: '🇧🇱', name: 'Saint Barthélemy' },
  { code: '+290', country: 'SH', flag: '🇸🇭', name: 'Saint Helena' },
  { code: '+1-869', country: 'KN', flag: '🇰🇳', name: 'Saint Kitts and Nevis' },
  { code: '+1-758', country: 'LC', flag: '🇱🇨', name: 'Saint Lucia' },
  { code: '+590', country: 'MF', flag: '🇲🇫', name: 'Saint Martin' },
  { code: '+508', country: 'PM', flag: '🇵🇲', name: 'Saint Pierre and Miquelon' },
  { code: '+1-784', country: 'VC', flag: '🇻🇨', name: 'Saint Vincent and the Grenadines' },
  { code: '+685', country: 'WS', flag: '🇼🇸', name: 'Samoa' },
  { code: '+378', country: 'SM', flag: '🇸🇲', name: 'San Marino' },
  { code: '+239', country: 'ST', flag: '🇸🇹', name: 'Sao Tome and Principe' },
  { code: '+966', country: 'SA', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+221', country: 'SN', flag: '🇸🇳', name: 'Senegal' },
  { code: '+381', country: 'RS', flag: '🇷🇸', name: 'Serbia' },
  { code: '+248', country: 'SC', flag: '🇸🇨', name: 'Seychelles' },
  { code: '+232', country: 'SL', flag: '🇸🇱', name: 'Sierra Leone' },
  { code: '+65', country: 'SG', flag: '🇸🇬', name: 'Singapore' },
  { code: '+1-721', country: 'SX', flag: '🇸🇽', name: 'Sint Maarten' },
  { code: '+421', country: 'SK', flag: '🇸🇰', name: 'Slovakia' },
  { code: '+386', country: 'SI', flag: '🇸🇮', name: 'Slovenia' },
  { code: '+677', country: 'SB', flag: '🇸🇧', name: 'Solomon Islands' },
  { code: '+252', country: 'SO', flag: '🇸🇴', name: 'Somalia' },
  { code: '+27', country: 'ZA', flag: '🇿🇦', name: 'South Africa' },
  { code: '+82', country: 'KR', flag: '🇰🇷', name: 'South Korea' },
  { code: '+211', country: 'SS', flag: '🇸🇸', name: 'South Sudan' },
  { code: '+34', country: 'ES', flag: '🇪🇸', name: 'Spain' },
  { code: '+94', country: 'LK', flag: '🇱🇰', name: 'Sri Lanka' },
  { code: '+249', country: 'SD', flag: '🇸🇩', name: 'Sudan' },
  { code: '+597', country: 'SR', flag: '🇸🇷', name: 'Suriname' },
  { code: '+47', country: 'SJ', flag: '🇸🇯', name: 'Svalbard and Jan Mayen' },
  { code: '+268', country: 'SZ', flag: '🇸🇿', name: 'Swaziland' },
  { code: '+46', country: 'SE', flag: '🇸🇪', name: 'Sweden' },
  { code: '+41', country: 'CH', flag: '🇨🇭', name: 'Switzerland' },
  { code: '+963', country: 'SY', flag: '🇸🇾', name: 'Syria' },
  { code: '+886', country: 'TW', flag: '🇹🇼', name: 'Taiwan' },
  { code: '+992', country: 'TJ', flag: '🇹🇯', name: 'Tajikistan' },
  { code: '+255', country: 'TZ', flag: '🇹🇿', name: 'Tanzania' },
  { code: '+66', country: 'TH', flag: '🇹🇭', name: 'Thailand' },
  { code: '+670', country: 'TL', flag: '🇹🇱', name: 'Timor-Leste' },
  { code: '+228', country: 'TG', flag: '🇹🇬', name: 'Togo' },
  { code: '+690', country: 'TK', flag: '🇹🇰', name: 'Tokelau' },
  { code: '+676', country: 'TO', flag: '🇹🇴', name: 'Tonga' },
  { code: '+1-868', country: 'TT', flag: '🇹🇹', name: 'Trinidad and Tobago' },
  { code: '+216', country: 'TN', flag: '🇹🇳', name: 'Tunisia' },
  { code: '+90', country: 'TR', flag: '🇹🇷', name: 'Turkey' },
  { code: '+993', country: 'TM', flag: '🇹🇲', name: 'Turkmenistan' },
  { code: '+1-649', country: 'TC', flag: '🇹🇨', name: 'Turks and Caicos Islands' },
  { code: '+688', country: 'TV', flag: '🇹🇻', name: 'Tuvalu' },
  { code: '+1-340', country: 'VI', flag: '🇻🇮', name: 'U.S. Virgin Islands' },
  { code: '+256', country: 'UG', flag: '🇺🇬', name: 'Uganda' },
  { code: '+380', country: 'UA', flag: '🇺🇦', name: 'Ukraine' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name: 'UAE' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
  { code: '+598', country: 'UY', flag: '🇺🇾', name: 'Uruguay' },
  { code: '+998', country: 'UZ', flag: '🇺🇿', name: 'Uzbekistan' },
  { code: '+678', country: 'VU', flag: '🇻🇺', name: 'Vanuatu' },
  { code: '+39', country: 'VA', flag: '🇻🇦', name: 'Vatican City' },
  { code: '+58', country: 'VE', flag: '🇻🇪', name: 'Venezuela' },
  { code: '+84', country: 'VN', flag: '🇻🇳', name: 'Vietnam' },
  { code: '+681', country: 'WF', flag: '🇼🇫', name: 'Wallis and Futuna' },
  { code: '+212', country: 'EH', flag: '🇪🇭', name: 'Western Sahara' },
  { code: '+967', country: 'YE', flag: '🇾🇪', name: 'Yemen' },
  { code: '+260', country: 'ZM', flag: '🇿🇲', name: 'Zambia' },
  { code: '+263', country: 'ZW', flag: '🇿🇼', name: 'Zimbabwe' },
  { code: '+358', country: 'AX', flag: '🇦🇽', name: 'Åland Islands' },
  { code: '+47', country: 'BV', flag: '🇧🇻', name: 'Bouvet Island' },
  { code: '+672', country: 'HM', flag: '🇭🇲', name: 'Heard Island and McDonald Islands' },
  { code: '+500', country: 'GS', flag: '🇬🇸', name: 'South Georgia & South Sandwich Islands' },
  { code: '+1', country: 'UM', flag: '🇺🇲', name: 'United States Minor Outlying Islands' }
];

const UserEditModal = ({ show, onHide, user, onSuccess }) => {
  const { t } = useTranslation();
  const { settings } = useTheme();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showTransactionPassword, setShowTransactionPassword] = useState(false);
  const [countryCode, setCountryCode] = useState('');
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [countrySearch, setCountrySearch] = useState('');
  const dropdownRef = useRef(null);

  // Filter countries based on search
  const filteredCountries = countryCodes.filter(country =>
    country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
    country.code.includes(countrySearch) ||
    country.country.toLowerCase().includes(countrySearch.toLowerCase())
  );

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: '',
      mobileNumber: '',
      resetPassword: '',
      transactionPassword: '',
      walletAddress: '',
      creditScore: 100,
      vipLevel: 0,
      isSimulated: false,
      controlLevel: 'none',
      isActive: true
    }
  });

  useEffect(() => {
    if (user) {
      setValue('username', user.username);
      setValue('email', user.email || '');

      // Parse existing mobile number to extract country code
      if (user.mobileNumber) {
        // Sort by code length descending to match longest code first
        const sortedCodes = [...countryCodes].sort((a, b) => b.code.length - a.code.length);
        const matchedCode = sortedCodes.find(c => user.mobileNumber.startsWith(c.code));

        if (matchedCode) {
          setCountryCode(matchedCode.code);
          setValue('mobileNumber', user.mobileNumber.replace(matchedCode.code, ''));
        } else {
          setCountryCode('');
          setValue('mobileNumber', user.mobileNumber);
        }
      } else {
        setCountryCode('');
        setValue('mobileNumber', '');
      }

      setValue('walletAddress', user.walletAddress || '');
      setValue('creditScore', user.creditScore ?? 0);
      setValue('vipLevel', user.vipLevel ?? 0);
      setValue('isSimulated', user.isSimulated ?? false);
      setValue('controlLevel', user.winLossControl?.controlLevel || 'none');
      setValue('isActive', user.isActive ?? true);
      setValue('resetPassword', '');
      setValue('transactionPassword', '');
    } else {
      setCountryCode('');
      reset({
        username: '',
        resetPassword: '',
        transactionPassword: '',
        walletAddress: '',
        creditScore: 100,
        vipLevel: 0,
        isSimulated: false,
        controlLevel: 'none',
        isActive: true
      });
    }
  }, [user, setValue, reset]);

  const onSubmit = async (data) => {
    // Validate country code if mobile number is provided
    if (data.mobileNumber && !countryCode) {
      setFormError(t('select_country_code', 'Please select a country code'));
      toast.error(t('select_country_code', 'Please select a country code'));
      setLoading(false);
      return;
    }

    setLoading(true);
    setFormError('');

    // Strict Credit Score Validation
    if (data.creditScore < 0 || data.creditScore > 100) {
      setFormError(t('error_credit_score_range'));
      toast.error(t('error_credit_score_range'));
      setLoading(false);
      return;
    }

    // Combine country code with mobile number if provided
    const submitData = { ...data };
    if (data.mobileNumber && !/^[0-9]{5,20}$/.test(data.mobileNumber)) {
      toast.error(t('mobile_invalid', 'Invalid mobile number'));
      return;
    }
    if (data.mobileNumber && countryCode) {
      submitData.mobileNumber = countryCode + data.mobileNumber;
    }

    try {
      let response;
      if (user) {
        response = await agentService.updateUser(user.id, submitData);
      } else {
        // For new user, we need a special "createUser" service call
        // If it doesn't exist, we should check agentService
        response = await agentService.createUser(submitData);
      }

      if (response.success) {
        toast.success(user ? t('user_updated_success') : t('user_created_success'));
        onSuccess();
        onHide();
      }
    } catch (error) {
      const msgKey = error.message || (user ? 'error_update_user' : 'error_create_user');
      const errorMsg = t(msgKey);
      setFormError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    reset();
    setFormError('');
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="md"
      contentClassName="border-0 shadow-lg"
      data-bs-theme={settings.darkMode ? 'dark' : 'light'}
    >
      <div style={{ backgroundColor: 'var(--bg-card)', color: 'var(--text-regular)', borderRadius: '8px', overflow: 'hidden' }}>
        <Modal.Header closeButton className="border-bottom border-light p-3">
          <Modal.Title className="fs-6 fw-bold text-primary">
            {user ? t('adjustment') : t('new_user')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {formError && <div className="alert alert-danger mb-3 py-2 small">{formError}</div>}
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* Username */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="username" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('username')}</Form.Label>
              <Form.Control
                id="username"
                name="username"
                type="text"
                {...register('username', { required: !user })}
                readOnly={!!user}
                placeholder={t('enter_username')}
                className={`bg-input border-color ${user ? 'text-secondary' : 'text-primary'}`}
                style={{ fontSize: '13px' }}
              />
            </Form.Group>

            {/* Email */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="email" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('email')}</Form.Label>
              <Form.Control
                id="email"
                name="email"
                type="email"
                {...register('email', {
                  required: !user,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: t('invalid_email_address') || "Invalid email address"
                  }
                })}
                placeholder={t('enter_email')}
                className={`bg-input border-color text-primary-text ${errors.email ? 'is-invalid' : ''}`}
                style={{ fontSize: '13px' }}
              />
            </Form.Group>

            {/* Mobile Number with Country Code */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="mobileNumber" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('mobile_number')}</Form.Label>
              <div className="mobile-input-container" style={{ width: '100%', flex: 1 }}>
                {/* Country Code Selector */}
                <div className="country-code-wrapper" ref={dropdownRef} style={{ position: 'relative' }}>
                  <button
                    type="button"
                    className={`country-code-button ${!countryCode ? 'border-warning country-code-empty' : ''}`}
                    onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                  >
                    {countryCode ? (
                      <>
                        <span className="country-flag">{countryCodes.find(c => c.code === countryCode)?.flag || '🌍'}</span>
                        <span className="country-code-text">{countryCode}</span>
                      </>
                    ) : (
                      <>
                        <i className="bi bi-globe-americas" style={{ fontSize: '14px', color: 'rgba(252, 213, 53, 0.7)' }}></i>
                        <span className="country-code-placeholder">{t('select_code', 'Code')}</span>
                      </>
                    )}
                    <i className={`bi bi-chevron-${showCountryDropdown ? 'up' : 'down'} dropdown-icon ms-auto`}></i>
                  </button>

                  {/* Country Dropdown */}
                  {showCountryDropdown && (
                    <div className="country-dropdown">
                      {/* Search Input */}
                      <div className="country-search-wrapper">
                        <i className="bi bi-search" style={{ color: 'rgba(252, 213, 53, 0.5)', marginRight: '8px' }}></i>
                        <input
                          id="countrySearch"
                          name="countrySearch"
                          type="text"
                          className="country-search-input"
                          placeholder={t('search_country', 'Search...')}
                          value={countrySearch}
                          onChange={(e) => setCountrySearch(e.target.value)}
                          autoFocus
                        />
                        {countrySearch && (
                          <button
                            type="button"
                            className="country-search-clear"
                            onClick={() => setCountrySearch('')}
                          >
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                      </div>

                      <div className="country-dropdown-scroll">
                        {filteredCountries.length > 0 ? (
                          filteredCountries.map((country, index) => (
                            <button
                              key={index}
                              type="button"
                              className="country-option"
                              onClick={() => {
                                setCountryCode(country.code);
                                setShowCountryDropdown(false);
                                setCountrySearch('');
                              }}
                            >
                              <span className="country-flag">{country.flag}</span>
                              <span className="country-name">{country.name}</span>
                              <span className="country-code">{country.code}</span>
                            </button>
                          ))
                        ) : (
                          <div className="country-no-results">
                            <i className="bi bi-search" style={{ fontSize: '24px', opacity: 0.3 }}></i>
                            <p>{t('no_countries_found', 'No countries found')}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Mobile Number Input */}
                <Form.Control
                  id="mobileNumber"
                  name="mobileNumber"
                  type="text"
                  {...register('mobileNumber', {
                    pattern: {
                      value: /^[0-9]+$/,
                      message: t('invalid_mobile_number') || "Invalid mobile number"
                    }
                  })}
                  placeholder={t('enter_mobile_number')}
                  className={`bg-input border-color text-primary-text mobile-number-input ${errors.mobileNumber ? 'is-invalid' : ''}`}
                  style={{ fontSize: '13px', flex: 1 }}
                />
              </div>
            </Form.Group>


            {/* Password */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="resetPassword" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('user_password')}</Form.Label>
              <InputGroup>
                <Form.Control
                  id="resetPassword"
                  name="resetPassword"
                  type={showPassword ? "text" : "password"}
                  placeholder={t('enter_user_password')}
                  {...register('resetPassword')}
                  className="bg-input border-color text-primary-text"
                  style={{ fontSize: '13px', borderRight: 'none' }}
                />
                <Button
                  variant="outline-secondary"
                  className="bg-input border-color text-secondary"
                  style={{ borderLeft: 'none' }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <VisibilityOff style={{ fontSize: '18px' }} /> : <Visibility style={{ fontSize: '18px' }} />}
                </Button>
              </InputGroup>
            </Form.Group>

            {/* Transaction Password */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="transactionPassword" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('user_transaction')}</Form.Label>
              <InputGroup>
                <Form.Control
                  id="transactionPassword"
                  name="transactionPassword"
                  type={showTransactionPassword ? "text" : "password"}
                  placeholder={t('enter_transaction_password')}
                  {...register('transactionPassword')}
                  className="bg-input border-color text-primary-text"
                  style={{ fontSize: '13px', borderRight: 'none' }}
                />
                <Button
                  variant="outline-secondary"
                  className="bg-input border-color text-secondary"
                  style={{ borderLeft: 'none' }}
                  onClick={() => setShowTransactionPassword(!showTransactionPassword)}
                >
                  {showTransactionPassword ? <VisibilityOff style={{ fontSize: '18px' }} /> : <Visibility style={{ fontSize: '18px' }} />}
                </Button>
              </InputGroup>
            </Form.Group>

            {/* Wallet Address */}
            <Form.Group className="mb-3 d-flex align-items-start">
              <Form.Label htmlFor="walletAddress" className="mb-0 small text-secondary mt-1" style={{ minWidth: '110px' }}>{t('wallet_address')}</Form.Label>
              <Form.Control
                id="walletAddress"
                name="walletAddress"
                as="textarea"
                rows={2}
                {...register('walletAddress')}
                className="bg-input border-color text-primary-text"
                style={{ fontSize: '13px' }}
              />
            </Form.Group>

            {/* Credit Score */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="creditScore" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('credit_score')}</Form.Label>
              <Form.Control
                id="creditScore"
                name="creditScore"
                type="number"
                min={0}
                max={100}
                {...register('creditScore', {
                  required: true,
                  min: { value: 0, message: 'Minimum 0' },
                  max: { value: 100, message: 'Maximum 100' },
                  valueAsNumber: true
                })}
                className="bg-input border-color text-primary-text"
                style={{ fontSize: '13px' }}
              />
            </Form.Group>

            {/* VIP Level */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="vipLevel" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('vip_level')}</Form.Label>
              <Form.Control
                id="vipLevel"
                name="vipLevel"
                type="number"
                min={0}
                max={3}
                {...register('vipLevel', {
                  min: { value: 0, message: 'Minimum 0' },
                  max: { value: 3, message: 'Maximum 3' },
                  valueAsNumber: true
                })}
                className={`bg-input border-color text-primary-text ${errors.vipLevel ? 'is-invalid' : ''}`}
                style={{ fontSize: '13px' }}
              />
            </Form.Group>

            {/* Simulate User */}
            <Form.Group className="mb-3 d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
              <Form.Label htmlFor="isSimulatedYes" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('simulate_user')}</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  id="isSimulatedYes"
                  label={t('yes')}
                  name="isSimulated"
                  checked={watch('isSimulated') === true}
                  onChange={() => setValue('isSimulated', true)}
                  className="small"
                />
                <Form.Check
                  type="radio"
                  id="isSimulatedNo"
                  label={t('no')}
                  name="isSimulated"
                  checked={watch('isSimulated') === false}
                  onChange={() => setValue('isSimulated', false)}
                  className="small"
                />
              </div>
            </Form.Group>

            {/* Win/Loss Control */}
            <Form.Group className="mb-3 d-flex align-items-start">
              <Form.Label htmlFor="controlLevelNone" className="mb-0 small text-secondary mt-1" style={{ minWidth: '110px' }}>
                {t('controlling_wins')}<br />{t('and_losses')}
              </Form.Label>
              <div className="d-flex flex-column gap-2">
                <Form.Check
                  type="radio"
                  id="controlLevelNone"
                  label={t('with_the_market')}
                  name="controlLevel"
                  checked={watch('controlLevel') === 'none'}
                  onChange={() => setValue('controlLevel', 'none')}
                  className="small"
                />
                <Form.Check
                  type="radio"
                  id="controlLevelHigh"
                  label={t('win')}
                  name="controlLevel"
                  checked={watch('controlLevel') === 'high'}
                  onChange={() => setValue('controlLevel', 'high')}
                  className="small"
                />
                <Form.Check
                  type="radio"
                  id="controlLevelLow"
                  label={t('deficit')}
                  name="controlLevel"
                  checked={watch('controlLevel') === 'low'}
                  onChange={() => setValue('controlLevel', 'low')}
                  className="small"
                />
              </div>
            </Form.Group>




            {/* State */}

            <Form.Group className="mb-4 d-flex align-items-center">
              <Form.Label htmlFor="isActiveYes" className="mb-0 small text-secondary mb-2 mb-sm-0" style={{ minWidth: '110px' }}>{t('state')}</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  id="isActiveYes"
                  label={t('normal')}
                  name="isActive"
                  checked={watch('isActive') === true}
                  onChange={() => setValue('isActive', true)}
                  className="small"
                />
                <Form.Check
                  type="radio"
                  id="isActiveNo"
                  label={t('disable')}
                  name="isActive"
                  checked={watch('isActive') === false}
                  onChange={() => setValue('isActive', false)}
                  className="small"
                />
              </div>
            </Form.Group>

            <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top border-light">
              <Button variant="secondary" size="sm" onClick={handleClose} className="px-4">
                {t('cancel')}
              </Button>
              <Button variant="primary" size="sm" type="submit" disabled={loading} className="px-5">
                {loading ? t('processing') : t('sure')}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default UserEditModal;